'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { getAnalyticsConfig } from '@/server/analytics/config';

const ANALYTICS_COOKIE = 'analytics_consent';
const OPT_OUT_COOKIE = 'ccpa_opt_out';

export default function AnalyticsScript() {
  const pathname = usePathname();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (pathname?.startsWith('/exp')) {
      setEnabled(false);
      return;
    }
    const analyticsConsent = readCookie(ANALYTICS_COOKIE);
    const optOut = readCookie(OPT_OUT_COOKIE) === '1';
    if (analyticsConsent === 'declined' || optOut) {
      setEnabled(false);
      return;
    }
    setEnabled(true);
  }, [pathname]);

  if (!enabled) return null;

  const config = getAnalyticsConfig();
  if (!config) return null;

  if (config.provider === 'umami') {
    return (
      <Script
        src={config.scriptUrl}
        data-website-id={config.websiteId}
        strategy="lazyOnload"
      />
    );
  }

  return null;
}

function readCookie(name: string) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${name}=`));
  return match ? match.split('=')[1] : null;
}
